import React, { useState, useEffect } from 'react';
import { BarChart, Bar,LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip
} from 'recharts';


const data = [
  { name: "Page A", uv: 4000, pv: 2400, amt: 2400 },
  { name: "Page B", uv: 3000, pv: 1398, amt: 2210 },
  { name: "Page C", uv: 2000, pv: 9800, amt: 2290 },
  { name: "Page D", uv: 2780, pv: 3908, amt: 2000 },
  { name: "Page E", uv: 1890, pv: 4800, amt: 2181 },
  { name: "Page F", uv: 2390, pv: 3800, amt: 2500 },
  { name: "Page G", uv: 3490, pv: 4300, amt: 2100 },
];




export default function ChartsCard() {

  //find current window width
  const [width, setWidth] = useState(window.innerWidth);
  
  const breakpoint = 768;
  //check if flex wrapped for mobile
  const isMobile = width <= breakpoint;


  //update window width state on resize
  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);
  }, []);

  return (
    <div
    style={{
      margin:"1rem",
      display:"flex",
      justifyContent:"space-around",
      alignItems:"center",
      flexWrap:"wrap"

    }}
    >
      
      
      <div>
      <LineChart width={
        isMobile ? width : width/3
      } height={300} data={data} margin={{ top: 5, right: 20, bottom: 5, left: 0 }}
      
      >
    <Line type="monotone" dataKey="uv" stroke="white" />
    <CartesianGrid stroke="white" strokeDasharray="5 5"
    
    />
    <XAxis dataKey="name" 
    stroke='white'
    />
    <YAxis 
    stroke='white'
    />
    <Tooltip />
  </LineChart>
      </div>



    <div>
    <BarChart width={
        isMobile ? width : width/3
    } height={300} data={data}>
    <XAxis dataKey="name" stroke="white" />
    <YAxis
    stroke='white'
    />
    <Tooltip />
    <CartesianGrid stroke="white" strokeDasharray="5 5" />
    <Bar dataKey="uv" fill="white" barSize={30} />
  </BarChart>

    </div>

    <div>

   
    </div>


      
    </div>
  )
}
